export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <div className="h-screen max-h-screen overflow-y-auto">
        <div className="px-5 pt-4 pb-9 max-w-[50rem] mx-auto flex flex-col gap-6">
          <h1 className="text-3xl font-black text-text tracking-tight">Terms of Service</h1>
          <p className="text-text-muted text-base leading-6">Last updated: June 2026</p>

          <p className="text-text text-sm leading-6">
            Welcome to Footslapping. These Terms of Service ("Terms") govern your access to and use
            of the website at footslapping.com and the Footslapping mobile application
            (collectively, the "Service"). By accessing or using the Service, you agree to be bound
            by these Terms. If you do not agree, please do not use the Service.
          </p>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">1. Eligibility</h2>
            <p className="text-text-muted text-sm leading-6">
              By using the Service, you represent and warrant that you are at least 18 years of age
              (or the age of majority in your jurisdiction) and have the full capacity to enter into
              these Terms. If you are under the required age, you may not use the Service.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">2. User Accounts</h2>
            <p className="text-text-muted text-sm leading-6">
              To access certain features of the Service, you may be required to register for an
              account. You must provide accurate, current, and complete information during
              registration. You are solely responsible for safeguarding your account credentials and
              for any activity that occurs under your account. You must notify us immediately of any
              unauthorized use of your account.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">
              3. Medical & Physical Activity Disclaimer
            </h2>
            <p className="text-text-muted text-sm leading-6">
              The Service is provided for motivational, informational, and entertainment purposes
              only. Footslapping is not a medical organization and nothing in the Service should be
              construed as medical advice. Participation in step competitions or any physical
              activity tracked by the Service involves inherent risks of injury. You explicitly
              agree that you are voluntarily participating and assume all risk of physical injury,
              illness, or damage. You should consult a physician before starting any new fitness
              routine.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">
              4. Fair Play & Anti-Cheating Policy
            </h2>
            <p className="text-text-muted text-sm leading-6">
              To maintain the integrity of competitions and leaderboards, you must compete fairly.
              We enforce a strict zero-tolerance policy regarding data manipulation. You agree not
              to manually manipulate, spoof, or falsify fitness data, use mechanical or automated
              methods to artificially inflate step counts, or reverse-engineer or tamper with API
              requests. We reserve the right to review user activity, disqualify users, wipe
              statistics, or permanently ban accounts suspected of violating this policy.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">5. User Content & Leaderboards</h2>
            <p className="text-text-muted text-sm leading-6">
              The Service may allow you to create competitions, invite users, and upload content
              including profile text, usernames, images, and comments ("User Content"). You retain
              ownership of your User Content but grant Footslapping a worldwide, royalty-free,
              perpetual, and non-exclusive license to use, reproduce, modify, display, and
              distribute your User Content to operate the platform. You are solely responsible for
              your User Content and agree not to post anything defamatory, obscene, abusive, or
              infringing on third-party rights.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">6. Prohibited Conduct</h2>
            <p className="text-text-muted text-sm leading-6">
              You agree not to violate any applicable law or regulation, engage in automated data
              mining or scraping of the Service, or introduce viruses, trojans, worms, or other
              malicious code designed to disrupt the Service.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">7. Intellectual Property</h2>
            <p className="text-text-muted text-sm leading-6">
              All content, features, and functionality of the Service — including text, graphics,
              logos, icons, images, software, and the "Footslapping" brand name — are the exclusive
              property of Footslapping or its licensors and are protected by international
              copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">8. App Store Terms</h2>
            <p className="text-text-muted text-sm leading-6">
              If you downloaded the app via the Apple App Store or Google Play Store, these Terms
              are between you and Footslapping only, not with the app store provider. You agree to
              comply with the applicable app store's terms of service.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">9. Termination & Data Forfeiture</h2>
            <p className="text-text-muted text-sm leading-6">
              We reserve the right to terminate or suspend your account and access to the Service
              for any reason, including breach of these Terms or suspected cheating. Upon
              termination, your right to use the Service ceases immediately and you forfeit all
              historical data, placement standings, and active ranks within competitions. We are not
              liable for any modification, suspension, or termination of the Service or loss of your
              data.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">
              10. Disclaimers & Limitation of Liability
            </h2>
            <p className="text-text-muted text-sm leading-6">
              The Service is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of
              any kind. Footslapping does not guarantee that the platform will be uninterrupted,
              error-free, or completely secure. To the maximum extent permitted by law, Footslapping
              shall not be liable for any indirect, incidental, special, consequential, or punitive
              damages arising out of or relating to your use of the Service.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">
              11. Governing Law & Dispute Resolution
            </h2>
            <p className="text-text-muted text-sm leading-6">
              These Terms shall be governed by the laws of the State of California. Any dispute
              arising out of or relating to these Terms or the Service will be resolved through
              binding, individual arbitration in Contra Costa County, California, rather than in
              court. You waive your right to participate in any class action or representative
              proceeding.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">12. Changes to These Terms</h2>
            <p className="text-text-muted text-sm leading-6">
              We reserve the right to update, modify, or revise these Terms at any time. Material
              changes will be notified to you by email, via an in-app notification, or by a
              prominent notice on the Service prior to the change becoming effective. Non-material
              changes may be made without advance notice. The "Last updated" date at the top of this
              page will reflect the most recent revision.
            </p>
            <p className="text-text-muted text-sm leading-6">
              Your continued use of the Service after any modifications constitutes your acceptance
              of the updated terms. If you do not agree with any changes, you should discontinue use
              and delete your account. We encourage you to periodically review this page for the
              latest information.
            </p>
          </section>

          <section className="flex flex-col gap-3">
            <h2 className="text-xl font-extrabold text-text">13. Contact Us</h2>
            <p className="text-text-muted text-sm leading-6">
              If you have questions about these Terms, please contact us at:
            </p>
            <p className="text-text text-sm leading-6">
              Email: support@footslapping.com
              <br />
              Website: https://footslapping.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
